import { Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { IOrganisation } from '@bciti/types';
import { ToastrService } from 'ngx-toastr';
import { of, Subject } from 'rxjs';
import { catchError, takeUntil, tap } from 'rxjs/operators';
import { UserImportService } from 'src/app/services/user-import/user-import.service';

@Component({
    selector: 'app-user-import-form',
    templateUrl: './user-import-form.component.html',
    styleUrls: ['./user-import-form.component.scss'],
})
export class UserImportFormComponent implements OnInit, OnChanges, OnDestroy {
    destroy$ = new Subject();

    @Input() org: IOrganisation;

    loading = false;

    form = new FormGroup({
        org: new FormControl(undefined, [Validators.required]),
        file: new FormControl(undefined, [Validators.required]),
    });

    get fileName() {
        return this.form.get('file')?.value?.name;
    }

    get getTitle(): string {
        return this.org ? `User import & invitation: ${this.org.name}` : 'User import & invitation';
    }

    constructor(private userImportService: UserImportService, private toastrService: ToastrService) {}

    ngOnInit(): void {}

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.org.currentValue?.tag) {
            this.form.patchValue({
                org: this.org,
            });
            console.log(this.form.value);
        }
    }

    onFileSelectChange(e: Event) {
        // validate selected file && validate content (make sure each row has values in each column)?
        const target = e.target as HTMLInputElement;
        const file: File = target.files[0];
        if (file) {
            this.form.patchValue({ file });
        }
    }

    onFileDropped(files: FileList) {
        if (files.item(0)) {
            this.prepFile(files.item(0));
        }
    }

    prepFile(file: File) {
        if (file) {
            this.form.patchValue({ file });
        }
        console.log(file, this.form.get('file').value);
    }

    clearFile() {
        this.form.patchValue({ file: undefined });
    }

    submitSelectedFile() {
        const file: File = this.form.get('file').value;
        if (file) {
            this.loading = true;
            this.userImportService
                .importUsers(file, this.org.tag)
                .pipe(
                    takeUntil(this.destroy$),
                    tap(() => {
                        this.form.reset();
                        this.loading = false;
                        // Successfully uploaded or users invited?
                        this.toastrService.success(`${file.name} was successfully uploaded`, 'Upload success');
                    }),
                    catchError((error) => {
                        this.loading = false;
                        this.toastrService.error(error?.error?.status, error?.error?.messages[0]);
                        return of(false);
                    }),
                )
                .subscribe();
        }
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }
}
